import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Footer } from 'primeng/api';
import { Observable } from 'rxjs';
import { FooterConstants } from '../constants/footer-constants';
import { environment } from 'src/environments/environment';
import { AuthConstants } from '../constants/auth/auth-constants';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class footerService {


  constructor(private readonly http: HttpClient, private environmentService: EnvironmentService) { } 

  PREMIERE_CONNEXION_ENDPOINT = this.environmentService.get().serverUrl + AuthConstants.PUBLIC_ENDPOINT + "/premiere_connexion";

  API_ENTRY_POINT = this.environmentService.get().serverUrl + '/ws/rest';
  PUBLIC_API_ENTRY_POINT = this.environmentService.get().serverUrl + '/ws/public/rest';


public getFooterById(idCompanySite: number): Observable<Footer> {
  return this.http.get<Footer>(`${this.API_ENTRY_POINT}${"/footer"}/${idCompanySite}`);
}

public getAppVersion(): Observable<string> {
  return this.http.get(`${this.PUBLIC_API_ENTRY_POINT}/version/get`, { responseType: 'text' });
}

}


